import Cookies from "js-cookie";

import CookieKeys from "../model/constants/cookieKeys";

export function getToken() {
    return Cookies.get(CookieKeys.AUTH_KEY) || null;
}

export function setToken(token) {
  return Cookies.set(CookieKeys.AUTH_KEY, token);
}

export function removeToken() {
  return Cookies.remove(CookieKeys.AUTH_KEY);
}

export function setPermissions(permissions) {
  return localStorage.setItem(CookieKeys.PERMISSIONS, JSON.stringify(permissions));
}

export function removePermissions() {
  return Cookies.remove(CookieKeys.PERMISSIONS);
}

export function removeUserDetails() {
  return Cookies.remove(CookieKeys.USER_DETAILS);
}

export function getPermissions() {
  let permissions = localStorage.getItem(CookieKeys.PERMISSIONS);
  if (permissions) {
    return JSON.parse(decodeURIComponent(permissions));
  }
  return null;
}

export function isGranted(permissionName) {
  if(permissionName != "admin_access"){
    return true;
  }
  let permissions = getPermissions();
  if (permissions == null) {
    return false;
  }
  return permissions.some(p => p.name === permissionName);
}

export function setUserDetails(details) {
  return localStorage.setItem(CookieKeys.USER_DETAILS, details);
}
